import { passwordErrorText } from "../../config";

const SERVER_ERROR_FIELDS = {
  old_password: "oldPassword",
  new_password: "newPassword",
  confirm_password: "confirmPassword",
};

/**
 * Maps password API error codes onto localized field errors.
 *
 * Used by PersonalPasswordModal today. Reuse this when the login page gets
 * an on-page English/Spanish toggle — pass that page's language, not
 * `user.preferred_language`, so guests can switch before they are signed in.
 *
 * @param {Object} errors Serializer error payload (`{ old_password: ["code"] }`).
 * @param {string} language Preferred language code (`en` or `es`).
 * @returns {Object} Local error state (`oldPassword`, `newPassword`, `confirmPassword`, `general`).
 */
export function mapServerPasswordErrors(errors, language) {
  const mapped = {};

  Object.entries(SERVER_ERROR_FIELDS).forEach(([apiField, localField]) => {
    if (!errors[apiField]) {
      return;
    }
    const codes = Array.isArray(errors[apiField])
      ? errors[apiField]
      : [errors[apiField]];
    mapped[localField] = codes
      .map((code) => passwordErrorText(code, language))
      .join(". ");
  });

  if (errors.non_field_errors) {
    const codes = Array.isArray(errors.non_field_errors)
      ? errors.non_field_errors
      : [errors.non_field_errors];
    mapped.general = codes
      .map((code) => passwordErrorText(code, language))
      .join(". ");
  }

  return mapped;
}
